<template>
<!--  <div :class="{ error: errorMessage }" class="main">-->
<!--    <div v-if="errorMessage" class="errorMessage">{{ errorMessage }}</div>-->
<!--    <App v-if="isLoginSuccess" />-->
<!--    <div v-else class="login-container">-->
<!--      <LoginComponent/>-->
<!--    </div>-->
<!--    <loader :load="isLoading" :isFull="isFullLoad"></loader>-->
<!--  </div>-->
  <v-app :class="!isLoginSuccess ? 'login-container' : null">
    <div v-if="errorMessage" class="errorMessage">{{ errorMessage }}</div>
    <div v-if="!isLoginSuccess" class="login-component">
      <LoginComponent></LoginComponent>
    </div>
    <div v-if="isLoginSuccess" class="d-flex flex-1">
        <navigation active-menu="/"
                    :user-fullname="$store.state.user.fullName"
                    current-year="2021"
                    app-name="Társasház hőkalkulátor"
                    current-version="4.00.017"
                    public-website="localhost"></navigation>

        <ScreenshotMaker></ScreenshotMaker>

        <v-main>
            <router-view />
        </v-main>
    </div>
    
    <loader :load="isLoading" :isFull="isFullLoad"></loader>
  </v-app>
</template>

<script>

import App from "./App.vue";
import LoginComponent from "./views/Login.vue";
import { AppStatus } from "./enums/AppStatus";
import Loader from "./components/Loader.vue";
import {Logout} from "@/enums/auth-actions";
import EventBus from "@/utils/event-bus";
import Navigation from "./components/Navigation";
import ScreenshotMaker from "./components/ScreenshotMaker";

let timerId = null;
let minutes = 0;
let seconds = 0;

export default {
  components: {
    App,
    LoginComponent,
    Navigation,
    Loader,
    ScreenshotMaker
  },
  data() {
    return {
      clipped: true,
      drawer: true,
      miniVariant: false,
      right: true,
      title: 'Smart Factory Operation Center',
      email: '',
      password: '',
      refreshTimer: null,
      hub: null,
      mainWebsocketHubStarted: null,
      logoutTime: null,
    };
  },
  props: {
    load: {
      type: Boolean,
      default: false
    },
    isFull: {
      type: Boolean,
      default: false
    },
  },
  async created() {
    EventBus.$on("START_LOGOUT_TIMER", () => this.startLogoutTimer());
    console.log(`%c ${this.$store.state.appStatus}`, 'background-color: blue; color: white');
    if (!this.$store.state.rememberMe &&
        this.$store.getters.isSessionExpired) {
      this.$store.dispatch('redirectForLogin');
    } else {
      this.$store.dispatch('loginWithRefreshToken').then((r) => {
        this.startLogoutTimer();
      });
    }
  },
  computed: {
    isLoading: function () {
      return (
          this.$store.state.appStatus === AppStatus.Logging ||
          this.$store.state.appStatus === AppStatus.Init ||
          this.$store.state.appStatus === AppStatus.AutoLogging ||
          this.$store.state.appStatus === AppStatus.AutoReLogging
      );
    },
    isFullLoad: function () {
      return (
          this.$store.state.appStatus === AppStatus.Init ||
          this.$store.state.appStatus === AppStatus.AutoLogging ||
          this.$store.state.appStatus === AppStatus.AutoReLogging
      );
    },
    isLoginSuccess: function () {
      return this.$store.state.appStatus === AppStatus.Success;
    },
    errorMessage: function () {
      return this.$store.state.errorMessage;
    },
    timerPretty() {
      if (!this.$store.state.isTimeout) {
        return;
      }
      minutes = Math.floor( this.logoutTime / 60);
      seconds =  this.logoutTime - minutes * 60;
      return `${(minutes).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}:${(seconds).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}`;
    },
  },
  methods: {
    logout() {
          this.$store.dispatch(Logout);
    },
    startLogoutTimer() {
      if (this.$store.state.isTimeout) {
        this.resetIdleTimer();
        timerId = setInterval(this.tickIdle, 1000);

        window.addEventListener("mousedown", this.resetIdleTimer);
        window.addEventListener("keydown", this.resetIdleTimer);
        window.addEventListener("touchstart", this.resetIdleTimer);
        window.addEventListener("resize", this.resetIdleTimer);
      }
    },
    resetIdleTimer() {
      this.logoutTime = 900;
    },
    tickIdle() {
      this.logoutTime -= 1;
      if(this.logoutTime < 0) {
        clearInterval(timerId);
        this.logout();
      }
    },
  },
}

</script>

<style lang="scss" scoped>
.main {
  height: 100%;
  display: grid;
  grid-template-rows: 1fr;
  &.error {
    grid-template-rows: 30px 1fr;
  }
}
.errorMessage {
  @import "scss/variables";
  z-index: 10000;
  background-color: $attention-color;
  color: white;
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 18px;
  display: flex;
  justify-content: center; /* align horizontal */
  align-items: center; /* align vertical */
  width: 500px;
}
.login-component {
    display: flex;
    flex: 1;
}
    .login-container {
        background-image: url("../public/img/background.png") !important;
        background-repeat: no-repeat !important;
        background-attachment: fixed !important;
        background-position: right 0 top 0 !important;
        background-size: auto;
        margin: 0 !important;
        padding: 0 !important;
        max-width: 100% !important;
    }
    @media (min-width: 1921px) {
        .login-container {
            background-size: cover;
        }
    }
    @media (min-height: 1081px) {
        .login-container {
            background-size: cover;
        }
    }
.showError {
  color: red;
}
</style>
